import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { router } from '@inertiajs/react';
import Layout from '../layout/Layout';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from '../config/theme';
import { keepPageParams } from '../utils/urlFunctions';
import { connectOtGroupsObserver, connectOtObserver, reloadOtBanner } from '../utils/onetrust.js';
import Honeybadger from '@honeybadger-io/js';
import ReactGA from 'react-ga4';
import ErrorPage from '../Pages/ErrorPage';
import '~/styles/application.css';

Honeybadger.configure({
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_RUBY_MODE,
  revision: 'main',
  debug: false,
});

document.addEventListener('DOMContentLoaded', connectOtObserver);
document.addEventListener('DOMContentLoaded', connectOtGroupsObserver);

ReactGA.initialize('G-HWY998BL67', {
  nonce: document.querySelector('meta[name="csp-nonce"]').content,
});

createInertiaApp({
  resolve: (name) => {
    const Pages = import.meta.glob('../Pages/**/*.jsx', { eager: true });
    const Page = Pages[`../Pages/${name}/index.jsx`];
    if (Page) {
      Page.default.layout = Page.default.layout || Layout;
      return Page;
    } else {
      return ErrorPage;
    }
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App initialPage={JSON.parse(document.getElementById('app').dataset.page)} {...props} />
      </ThemeProvider>,
    );
  },
});

router.on('navigate', (event) => {
  let newUrl = keepPageParams(event.detail.page.url);
  if (newUrl != window.pgePrevUrl) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      url: event.detail.page.url,
      event: 'pageview',
    });
    var ftGoal = new Image();
    ftGoal.src =
      'https://servedby.flashtalking.com/spot/1/5823;130525;9210/?spotName=PG_E_Marketplace_Homepage_activity&cachebuster=' +
      parseInt(Math.random() * 9e9);
  }
  window.pgePrevUrl = newUrl;
  reloadOtBanner();
});
